import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-radar "},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0002 2L22.0102 9.27269L18.1868 21.0402H5.81371L1.99023 9.27269L12.0002 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0002 2L22.0102 9.27269M12.0002 2L1.99023 9.27269M12.0002 2L12 12.5251M22.0102 9.27269L18.1868 21.0402M22.0102 9.27269L12 12.5251M18.1868 21.0402H5.81371M18.1868 21.0402L12 12.5251M5.81371 21.0402L1.99023 9.27269M5.81371 21.0402L12 12.5251M1.99023 9.27269L12 12.5251","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartRadar = Vue.extend<IconProps>({
  name: 'ChartRadarIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-radar',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartRadar;
